import { render, staticRenderFns } from "./BasisNav.vue?vue&type=template&id=2e9e610c&scoped=true&"
import script from "./BasisNav.vue?vue&type=script&lang=js&"
export * from "./BasisNav.vue?vue&type=script&lang=js&"
import style0 from "./BasisNav.vue?vue&type=style&index=0&id=2e9e610c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9e610c",
  null
  
)

export default component.exports